/**
 * Run after the browser has painted (two animation frames).
 * useEffect already runs after commit; the extra frames let the list layout first.
 */
export function runAfterPaint(callback) {
  if (typeof requestAnimationFrame !== 'function') {
    const timer = setTimeout(callback, 0);
    return () => clearTimeout(timer);
  }

  let cancelled = false;
  let frame2 = 0;
  const frame1 = requestAnimationFrame(() => {
    frame2 = requestAnimationFrame(() => {
      if (!cancelled) callback();
    });
  });

  return () => {
    cancelled = true;
    cancelAnimationFrame(frame1);
    cancelAnimationFrame(frame2);
  };
}
